//based on https://github.com/miklblitz/angular2-image-upload_uploaded/blob/master/README.md
import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { ImageService, Header } from '../../../../services/image.service';
import { Observable } from 'rxjs';

export class FileHolder {
  public serverResponse: any;
  public pending: boolean = false;
  constructor(public src: string, public file: File, public id?: number) { }
}

@Component({
    selector: 'image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.css'],
    standalone: false
})

export class ImageUploadComponent implements OnInit {

  @Input() uploaded: Array<Object>; // массив url фото, добавлено мной
  @Input() icandelete: boolean = false;

  @Input() max: number = 1;
  @Input() url: string;
  @Input() headers: Header[];
  @Input() preview: boolean = true;

  @Output()
  private isPending: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  private onFileUploadFinish: EventEmitter<FileHolder> = new EventEmitter<FileHolder>();
  @Output()
  private onRemove: EventEmitter<FileHolder> = new EventEmitter<FileHolder>();

  public files: FileHolder[] = [];

  private fileCounter: number = 0;
  private pendingFilesCounter: number = 0;
  public isFileOver: boolean = false;

  constructor(private imageService: ImageService) { }

  ngOnInit() {
    this.imageService.setUrl(this.url);

    // сбор загруженных фото в массив
    if (typeof this.uploaded !== 'undefined')
      if (this.uploaded.length > 0)
      {
        for (var i = 0; i < this.uploaded.length; i++) {
          this.imageService.convertFileToDataURLviaFileReader(this.uploaded[i], i, this.headers).subscribe(
            response => {
              let fileHolder: FileHolder = new FileHolder(response.image, new File([response.image], 'file.jpg'), response.id);
              this.files.push(fileHolder);
              this.max--;
              this.onFileUploadFinish.emit(fileHolder);
            }
          );
        }
      }
  }

  fileChange(files) {
    if (this.max == 0 && this.files.length > 0)
      this.deleteFile(this.files[0]);

    let remainingSlots = this.countRemainingSlots();
    let filesToUploadNum = files.length > remainingSlots ? remainingSlots : files.length;

    if (this.url && filesToUploadNum != 0) {
      this.isPending.emit(true);
    }

    this.fileCounter += filesToUploadNum;

    this.uploadFiles(files, filesToUploadNum);
  }

  private uploadFiles(files, filesToUploadNum) {
    for (let i = 0; i < filesToUploadNum; i++) {
      let file = files[i];

      let img = document.createElement('img');
      img.src = window.URL.createObjectURL(file);

      let reader = new FileReader();
      reader.addEventListener('load', (event: any) => {
        let fileHolder: FileHolder = new FileHolder(event.target.result, file);

        fileHolder.serverResponse = `good boy: ${i}`;

        //this.uploadSingleFile(fileHolder);

        this.uploadSingleFile(fileHolder).subscribe(data => {
          if (data.result === 'ok') {
            fileHolder.id = data.response.id;
          }
        });

        this.files.push(fileHolder);
        this.onFileUploadFinish.emit(fileHolder);

      }, false);

      reader.readAsDataURL(file);
    }
  }

  private uploadSingleFile(fileHolder: FileHolder) {
    return Observable.create(observer => {
      if (this.url) {
        this.pendingFilesCounter++;
        fileHolder.pending = true;

        this.imageService.postImage(fileHolder.file, this.headers).subscribe(response => {
          fileHolder.serverResponse = response;
          fileHolder.pending = false;
          if (--this.pendingFilesCounter == 0) {
            this.isPending.emit(false);
          }
          observer.next({ 'result': 'ok', 'response': JSON.parse(response) }); observer.complete();
        });

      } else
      {
        observer.next({ 'result': 'error' }); observer.complete();
      }
    });
  }

  public deleteFile(file: FileHolder): void {
    // от коллбека пришел тру -> значит можно убирать иконку
    // if(this.icandelete) {
    let index = this.files.indexOf(file);
    this.files.splice(index, 1);
    this.fileCounter--;

    this.onRemove.emit(file);
    // }
  }

  fileOver(isOver) {
    this.isFileOver = isOver;
  }

  private countRemainingSlots() {
    return this.max - this.fileCounter;
  }


  get value(): any[] {
    return this.files;
  }
  public onFileClick(file: FileHolder)
  {
    //this.input.click();

  }
}
